import { type Page } from './constants';
import createErrors from '../createErrors';

export type Component = 'AutoshipPage';

/**
 * Errors related to the Activate Offer page
 */
export const Errors = createErrors<Page, Component>('Autoship')({
    AutoshipPage: {
        SetOrdergrooveAuthCookieFailed: {
            severity: 'HIGH',
            message: 'Failed to set Ordergroove auth cookie for Autoship page',
        },
        LoadOrdergrooveScriptFailed: {
            severity: 'HIGH',
            message: 'Failed to load Ordergroove script on Autoship page',
        },
        NoOgCustomerIdFound: {
            severity: 'MEDIUM',
            message: 'No OG customerId found',
        },
        GenerateOrdergrooveAuthSignatureFailed: {
            severity: 'HIGH',
            message: 'Failed to generate Ordergroove auth signature',
        },
    },
});
